import { render, staticRenderFns } from "./ShareSurveyCourseView.vue?vue&type=template&id=f1f01f7c&lang=pug"
import script from "./ShareSurveyCourseView.vue?vue&type=script&lang=js"
export * from "./ShareSurveyCourseView.vue?vue&type=script&lang=js"
import style0 from "./ShareSurveyCourseView.vue?vue&type=style&index=0&id=f1f01f7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports